// src/pdf/expedientePDF.js

import { createPdfEngine } from "./pdfEngine";
import {
  imprimirIdentificacion,
  imprimirHistoriaInicial,
  imprimirNotasEvolucion,
  imprimirAnexoSignos,
  
} from "./expedienteSections";

/**
 * Genera el expediente clínico completo NOM-004
 * Todo frontend
 * Sin almacenamiento
 * Texto vectorial
 */
export function generarExpedientePDF({
  paciente,
  historiaClinica,
  medico,
  logoDoctorBase64 = null,
  consultas = [],
  soloConsulta = false,
  catalogos = {},
}) {

  const engine = createPdfEngine({
    medico,
    paciente,
    logoDoctorBase64
  });

// =====================================================
// 🔹 CASO 1: SOLO UNA CONSULTA SELECCIONADA
// =====================================================
if (soloConsulta && consultas && consultas.length === 1) {
  
  const consultasOrdenadas = [...consultas]
    .map((c) => ({
      ...c,
      __fechaOrden: c?.fechaConsulta || c?.fecha_consulta || c?.creado_en,
    }))
    .sort((a, b) => new Date(a.__fechaOrden) - new Date(b.__fechaOrden));

  imprimirNotasEvolucion(
    engine,
    consultasOrdenadas,
    medico,
    catalogos
  );

} else {

  // ===============================
  // HOJA 1 — IDENTIFICACIÓN
  // ===============================
  imprimirIdentificacion(engine, {
    paciente,
    historiaClinica,
    medico
  });

  // ===============================
  // HISTORIA CLÍNICA INICIAL 6.1
  // ===============================
  if (historiaClinica) {
    imprimirHistoriaInicial(engine, historiaClinica, catalogos);
  }

  // ===============================
  // NOTAS DE EVOLUCIÓN 6.2
  // ===============================
   // Ordena seguimientos en orden cronológico (2,3,4...) usando el mismo fallback que ConsultasPaciente
    const consultasOrdenadas = [...(historiaClinica?.consultas || [])]
      .map((c) => ({
        ...c,
        __fechaOrden: c?.fechaConsulta || c?.fecha_consulta || c?.creado_en,
      }))
      .sort((a, b) => new Date(a.__fechaOrden) - new Date(b.__fechaOrden));

    imprimirNotasEvolucion(
      engine,
      consultasOrdenadas,
      medico,
      catalogos
    );

  // ===============================
  // ANEXO I — SIGNOS VITALES
  // ===============================
  const registrosSignos = [];
  const formatFecha = (d) => {
  if (!d) return "";
  const date = new Date(d);
  return date.toLocaleDateString("es-MX", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  };

  if (historiaClinica) {

    // 🔹 Historia clínica inicial
    registrosSignos.push({
      fecha: formatFecha(historiaClinica.fechaConsulta),
      peso: historiaClinica["exploracionFisica.peso"],
      talla: historiaClinica["exploracionFisica.altura"],
      ta: historiaClinica.sistolica && historiaClinica.diastolica
        ? `${historiaClinica.sistolica}/${historiaClinica.diastolica}`
        : "",
      fc: historiaClinica["exploracionFisica.signosVitales.frecuenciaCardiaca"],
      fr: historiaClinica["exploracionFisica.signosVitales.frecuenciaRespiratoria"],
      temp: historiaClinica["exploracionFisica.signosVitales.temperatura"],
      spo2: historiaClinica["exploracionFisica.signosVitales.saturacionOxigeno"],
      imc: historiaClinica.imc,
      cintura: historiaClinica.circunferenciaCintura,
      glucosa: historiaClinica.glucemia
    });

    // 🔹 Consultas de seguimiento
    if (Array.isArray(historiaClinica.consultas)) {
      historiaClinica.consultas.forEach(c => {
        registrosSignos.push({
          fecha: formatFecha(c.fechaConsulta),
          peso: c["exploracionFisica.peso"],
          talla: c["exploracionFisica.altura"],
          ta: c.sistolica && c.diastolica
            ? `${c.sistolica}/${c.diastolica}`
            : "",
          fc: c["exploracionFisica.signosVitales.frecuenciaCardiaca"],
          fr: c["exploracionFisica.signosVitales.frecuenciaRespiratoria"],
          temp: c["exploracionFisica.signosVitales.temperatura"],
          spo2: c["exploracionFisica.signosVitales.saturacionOxigeno"],
          imc: c.imc,
          cintura: c.circunferenciaCintura,
          glucosa: c.glucemia
        });
      });
    }
  }

  if (registrosSignos.length > 0) {
    imprimirAnexoSignos(engine, registrosSignos);
  }
}
  // ===============================
  // EXPORTAR
  // ===============================
  engine.save("expediente_clinico.pdf");
}
